// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"b84e27b1","359":"9af2dc56","361":"54585a09"}[chunkId] + ".chunk.js";
};